"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.propertyUrls = exports.propertyBrands = exports.properties = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var types = exports.types = {
  TELUS: 'telus',
  KOODO: 'koodo'
};
var properties = exports.properties = {
  TELUS: 'telus',
  MY_TELUS: 'myTelus',
  KOODO_SELF_SERVE: 'koodoSelfServe',
  KOODO_COMMERCE: 'koodoCommerce',
  KOODO_SOD: 'koodoSOD',
  NGC: 'ngc'
};
var propertyBrands = exports.propertyBrands = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, properties.TELUS, types.TELUS), properties.MY_TELUS, types.TELUS), properties.KOODO_SELF_SERVE, types.KOODO), properties.KOODO_COMMERCE, types.KOODO), properties.KOODO_SOD, types.KOODO);
var propertyUrls = exports.propertyUrls = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, properties.TELUS, {
  production: 'https://assets.adobedtm.com/launch-EN3a616363ba5741cbbdbab4982624983c.min.js',
  staging: 'https://assets.adobedtm.com/launch-EN9808d87e565240b8b540732e616c48dc-staging.min.js'
}), properties.MY_TELUS, {
  production: 'https://assets.adobedtm.com/launch-EN65f579f00cb04596bfa8bad1911ad8fa.min.js',
  staging: 'https://assets.adobedtm.com/launch-ENdd4142b4bbfc4721982dd14bc0f2c424-staging.min.js'
}), properties.KOODO_SELF_SERVE, {
  production: 'https://assets.adobedtm.com/a2962fe01e14/5fdbd7b18e3f/launch-EN14939a155e7b427ca2bab62299f1df2a.min.js',
  staging: 'https://assets.adobedtm.com/a2962fe01e14/5fdbd7b18e3f/launch-EN544d4acc4003489880a13b746073eae2-staging.min.js'
}), properties.KOODO_COMMERCE, {
  production: 'https://assets.adobedtm.com/a2962fe01e14/ec556f4805a8/launch-02f63a92b861.min.js',
  staging: 'https://assets.adobedtm.com/a2962fe01e14/ec556f4805a8/launch-d3ffc97e9ec8-staging.min.js'
}), properties.KOODO_SOD, {
  production: 'https://assets.adobedtm.com/a2962fe01e14/4da935ea86d5/launch-65d062d4b4b4.min.js',
  staging: 'https://assets.adobedtm.com/a2962fe01e14/4da935ea86d5/launch-b0e264eb5e17-staging.min.js'
}), properties.NGC, {
  production: 'https://assets.adobedtm.com/a2962fe01e14/ef322c9b9570/launch-c3b12a02ad27.min.js',
  staging: 'https://assets.adobedtm.com/a2962fe01e14/ef322c9b9570/launch-4a7d03ac5d9f-staging.min.js'
});